export default __webpack_public_path__ + "static/media/web2.5c129738.jpg";